import type { FirebaseRepository } from '../models/FirebaseRepository'
import { Cubit } from './core'
import { fetchSection } from '../firestore/Section'

/**
 * The only job of this cubit is to expose `fetchSection`
 *
 * it's purely a middleman as the pattern of our repo is to not expose queries directly
 * to the client.
 */
export class CreateOrEditSectionDialogCubit extends Cubit {
  repository: FirebaseRepository

  constructor(repository: FirebaseRepository) {
    super()
    this.repository = repository
  }

  fetchSection = (sectionId: string) => {
    return fetchSection(this.repository, { sectionId })
  }
}
